export const quoteCreditMap: { [screen: string]: { [key: string]: string } } = {
  continueWithEmailOrGmail: {
    quote:
      'Almanac is how we gather feedback and get documents approved, which is vital for moving ideas forward on a fully remote team.',
    credit: 'Kaelin Hooper',
    avatar:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1666720729/registrationAvatars/kaelinHooper_ts7mht.jpg',
    jobTitle: 'Co-founder and CTO, Ender',
  },
  checkEmailOrEnterVerificationCode: {
    quote: "I'm speechless. Almanac is so good. I wasn't expecting to be blown away by this product. Like, WOW.",
    credit: 'Vladimir Petroski',
    avatar:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1657205575/registrationAvatars/vladimirPetroski_e7k1ev.png',
    jobTitle: 'Web Designer, V/P',
  },
  createAccount: {
    quote:
      'Almanac is building the future of the documentation tools for teams. Reviews, approvals, merging, history, super great multiplayer.',
    credit: 'Job van der Voort',
    avatar:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1657205574/registrationAvatars/jobVanDerVoort_s9yvl3.png',
    jobTitle: 'CEO at Remote.com',
  },
  trial: {
    quote:
      'I love what Almanac is doing for documentation. Super critical piece of the remote infrastructure that many teams are still struggling to do at a high level.',
    credit: 'Chase Warrington',
    avatar:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1657205574/registrationAvatars/chaseWarrington_znavcj.png',
    jobTitle: 'Head of Remote, Doist',
  },
  trialCard: {
    quote:
      "The world at large doesn't yet know how big of a deal Structured Approvals are for docs, a key element of Almanac. As handbooks become commonplace in organized companies, I anticipate a lot of a-ha moments.",
    credit: 'Darren Murph',
    avatar:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1657205574/registrationAvatars/darrenMurph_txbe0n.png',
    jobTitle: 'Head of Remote, GitLab',
  },
  checkYourInboxForPasswordResetEmail: {
    quote:
      "We're huge fans of Almanac so far. Almanac is going to be really good for our business. The mindset that you guys have, in terms of the async approach and branching, is right in line with how we think about our business. We're really excited about Almanac.",
    credit: 'Drew Cohen',
    avatar:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1657205575/registrationAvatars/drewAvatar_hwvt6q.png',
    jobTitle: 'Principal, Corporate Infrastructure, Nova',
  },
  enterPassword: {
    quote:
      'The whole product feels as if a software engineer got really frustrated and took lessons from writing code and moved them into writing documents.',
    credit: 'Ilya Nekhay',
    avatar:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1657205791/registrationAvatars/ilyaNekhay_ob8gfy.png',
    jobTitle: 'Engineering Manager at Indeed',
  },
  usingSamlSso: {
    quote: 'I mean, the documents are gorgeous.',
    credit: 'BreAnne Toepper',
    avatar:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1657205574/registrationAvatars/breAnneToepper_jflmwk.png',
    jobTitle: "Operations Manager, Don's Appliances",
  },
  demoScheduled: {
    quote:
      'Almanac feels as if a software engineer, frustrated with existing solutions, applied lessons from writing code to documents.',
    credit: 'Ilya Nekhay',
    avatar:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1657205791/registrationAvatars/ilyaNekhay_ob8gfy.png',
    jobTitle: 'Engineering Manager at Indeed',
  },
  companyData: {
    quote:
      'This is an absolute game changer. If you want to implement processes into a company, Almanac is the smoothest way to do it.',
    credit: 'Aron Grinshtein',
    avatar:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1666720732/registrationAvatars/aronGrinshtein_rvgoyx.jpg',
    jobTitle: 'CEO, Kingfisher Medical',
  },
}
